/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { Panel } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import { routerActions } from 'react-router-redux';
import LineChart from 'loracoms/LineChart';
import DetailEye from 'loracoms/DetailEye';
import Refresher from 'loracoms/Refresher';
import CollapseToggle from 'loracoms/CollapseToggle';
import IntlMsg from 'lorautils/intl/IntlMsg';
import { callAPI } from 'lorautils/api';
import format from 'date-fns/format';
import addHours from 'date-fns/add_hours';
import subDays from 'date-fns/sub_days';

const propTypes = {
  appId: React.PropTypes.string.isRequired,
  deviceId: React.PropTypes.string.isRequired,
  pushState: React.PropTypes.func.isRequired,
  intl: React.PropTypes.any.isRequired,
};

class DeviceBriefPktTrend extends React.Component {

  constructor(props) {
    super(props);
    this.intlMsg = new IntlMsg(props.intl, 'devicedetail.detailview');
    this.state = {
      series: {
        rxpks: {
          name: this.intlMsg.msg('series.packets'),
          data: [],
          yAxisIndex: 0,
        },
        categories: [],
      },
    };
    this.loadData = this.loadData.bind(this);
  }

  componentWillMount() {
    this.loadData();
  }

  loadData() {
    const { deviceId } = this.props;
    const from = format(subDays(new Date(), 7), 'YYYYMMDDHH');
    const to = format(addHours(new Date(), 1), 'YYYYMMDDHH');

    this.setState({ reloading: true });

    callAPI({
      endpoint: `/lora/nodes/${deviceId}/stats?from=${from}&to=${to}`,
    }).then((data) => {
      const rxpks = [];
      const slots = [];
      data.list.forEach((item) => {
        const s = item.slot.toString();
        const slot = `${s.slice(6, 8)}/${s.slice(4, 6)} ${s.slice(8, 10)}:00`;
        slots.push(slot);
        rxpks.push(item.rxpkt);
      });
      const series = _.extend({}, this.state.series);
      series.rxpks.data = rxpks;
      series.categories = slots;
      this.setState({ series, reloading: false });
    }).catch(() => {});
  }

  render() {
    const { appId, deviceId, pushState } = this.props;
    const { reloading = false, series, expanded = true, resizeTrigger = 0 } = this.state;
    const header = (
      <div>
        {this.intlMsg.msg('devicestatus')}
        <ul className="icontools">
          <li>
            <DetailEye onClick={() => pushState(`/application/${appId}/devices/${deviceId}/stat`)} />
          </li>
          <li>
            <Refresher
              reloading={reloading}
              onReload={this.loadData}
            />
          </li>
          <li>
            <CollapseToggle
              expanded={expanded}
              onChange={(v) => { this.setState({ expanded: v }); }}
            />
          </li>
        </ul>
      </div>
    );

    return (
      <Panel
        bsStyle="aisz-white"
        header={header}
        collapsible
        expanded={expanded}
        onEntered={() => {
          this.setState({ resizeTrigger: Math.random() });
        }}
      >
        <LineChart
          yAxis={[{
            name: this.intlMsg.msg('series.packets'),
            splitNumber: 5,
          }]}
          xAxis={{
            axisTick: {
              alignWithLabel: true,
            },
            boundaryGap: true,
          }}
          grid={{
            left: 60,
            top: 30,
            right: 30,
            bottom: 30,
          }}
          series={[series.rxpks]}
          categories={series.categories}
          resizeTrigger={resizeTrigger}
        />
      </Panel>
    );
  }
}

DeviceBriefPktTrend.propTypes = propTypes;

const mapDispatchToProps = {
  pushState: routerActions.push,
};

export default connect(
  null,
  mapDispatchToProps,
)(injectIntl(DeviceBriefPktTrend));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/DeviceDetail/coms/DeviceBriefPktTrend/index.jsx